import styled from 'styled-components';

export const StyledAdminCalendarContainer = styled.div`
  color: ${(props) => (props.theme.id === 'dark' ? props.theme.accent2 : props.theme.accent1)};

  .calendar-back-layer {
    padding-top: 2.3rem;
  }
`;
